<div *ngFor="let constraint of this.constraints"><small>{{constraint}}</small></div>